var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { fontSizes, fontWeights, spacing, } from "syf-component-library/defaultTheme";
import query from "syf-component-library/const/mediaQueries";
import { colors } from "../../../../../ui/theme";
var CERTIFICATE_STATUS_STYLES = {
    USED: {
        fontColor: colors.mughalGreen,
        backgroundColor: colors.nyanza,
    },
    EXPIRED: {
        fontColor: colors.auburn,
        backgroundColor: colors.lavenderBlush,
    },
};
export var Container = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 9px;\n  color: ", ";\n  background-color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  margin-right: 36px;\n  padding: 0 ", "px;\n\n  @media ", " {\n    margin-right: ", "px;\n  }\n"], ["\n  border-radius: 9px;\n  color: ", ";\n  background-color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  margin-right: 36px;\n  padding: 0 ", "px;\n\n  @media ", " {\n    margin-right: ", "px;\n  }\n"])), function (_a) {
    var $statusType = _a.$statusType;
    return CERTIFICATE_STATUS_STYLES[$statusType].fontColor;
}, function (_a) {
    var $statusType = _a.$statusType;
    return CERTIFICATE_STATUS_STYLES[$statusType].backgroundColor;
}, fontSizes.small, fontWeights.semiBold, spacing.medium, query.lessThanMedium, spacing.base);
var templateObject_1;
